import { render, staticRenderFns } from "./khgl.vue?vue&type=template&id=14324005&scoped=true&"
import script from "./khgl.vue?vue&type=script&lang=js&"
export * from "./khgl.vue?vue&type=script&lang=js&"
import style0 from "./khgl.vue?vue&type=style&index=0&id=14324005&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14324005",
  null
  
)

export default component.exports